import React, { Component, Fragment } from "react";
import Breadcrumb from "../../common/breadcrumb";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
import Datatable from "./customerDatatable";
import { Tabs, TabList, TabPanel, Tab } from "react-tabs";
import { getAllCustomerLoansRedux } from "../../../actions/index";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { DollarSign } from "react-feather";
import CountUp from "react-countup";
import "./loan.css";
export class Customers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      toggleModal: true,
      employee: null,
    };
  }

  componentDidMount = async () => {
    this.props.getAllCustomerLoansRedux();
  };

  startToggleModal = async (employeeObj) => {
    if (employeeObj == null) {
      this.setState({ toggleModal: !this.state.toggleModal, employee: null });
    } else {
      this.setState({
        toggleModal: !this.state.toggleModal,
        employee: employeeObj,
      });
    }
  };
  clickActive = (event) => {
    document.querySelector(".nav-link").classList.remove("show");
    event.target.classList.add("show");
  };
  render() {
    const { open } = this.state;
    const { allCustomers } = this.props;
    let dueCustomers = allCustomers.filter((customer) => customer.amount > 0);
    let algDueCustomers = allCustomers.filter(
      (customer) => customer.amount < 0
    );
    let totalCustomerDue = 0;
    let totalAlgDue = 0;
    dueCustomers.map((customer) => {
      totalCustomerDue += customer.amount;
    });
    algDueCustomers.map((customer) => {
      totalAlgDue += customer.amount;
    });

    console.log(this.props);
    return (
      <Fragment>
        <Breadcrumb title="Loans" parent="Cash in/out" />
        {/* <!-- Container-fluid starts--> */}
        <div className="container-fluid ln-page kd-cash kd-st--peach">
          <div className="row ln-stats-row" style={{ justifyContent: "center" }}>
            <div className="col-xl-3 col-md-6 xl-50">
              <div className="ln-stat-card">
                <div className="ln-stat-icon ln-stat-icon--success">
                  <DollarSign />
                </div>
                <div>
                  <div className="ln-stat-eyebrow ln-stamp-font">Total Customer Due</div>
                  <div className="ln-stat-value">
                    <CountUp className="counter" end={totalCustomerDue} />
                    Tk
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-md-6 xl-50">
              <div className="ln-stat-card">
                <div className="ln-stat-icon ln-stat-icon--danger">
                  <DollarSign />
                </div>
                <div>
                  <div className="ln-stat-eyebrow ln-stamp-font">Total KIDO debt</div>
                  <div className="ln-stat-value">
                    <CountUp className="counter" end={totalAlgDue} />
                    Tk
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <Tabs>
              <TabList
                className="nav nav-tabs tab-coupon ln-tablist"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                }}
              >
                <Tab className="nav-link ln-tab" onClick={(e) => this.clickActive(e)}>
                  Customer Due
                </Tab>

                <Tab className="nav-link ln-tab" onClick={(e) => this.clickActive(e)}>
                  KIDO debt
                </Tab>
              </TabList>
              <TabPanel>
                <div className="row">
                  <div className="col-sm-12">
                    <div className="card ln-card">
                      <div className="card-header ln-card-header">
                        <h5 className="ln-card-title">
                          <i className="icofont-bill ln-card-icon"></i>
                          Customer Due
                        </h5>
                      </div>
                      <div className="card-body">
                        <div className="clearfix"></div>
                        <div id="basicScenario" className="product-physical">
                          <Datatable
                            startToggleModal={this.startToggleModal}
                            history={this.props.history}
                            multiSelectOption={false}
                            myData={dueCustomers}
                            pageSize={50}
                            pagination={true}
                            className="-striped -highlight"
                            type="expense"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </TabPanel>
              <TabPanel>
                <div className="row">
                  <div className="col-sm-12">
                    <div className="card ln-card">
                      <div className="card-header ln-card-header">
                        <h5 className="ln-card-title">
                          <i className="icofont-bill ln-card-icon"></i>
                          KIDO debt
                        </h5>
                      </div>
                      <div className="card-body">
                        <div className="clearfix"></div>
                        <div id="basicScenario" className="product-physical">
                          <Datatable
                            startToggleModal={this.startToggleModal}
                            history={this.props.history}
                            multiSelectOption={false}
                            myData={algDueCustomers}
                            pageSize={50}
                            pagination={true}
                            className="-striped -highlight"
                            type="cashIn"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </TabPanel>
            </Tabs>
          </div>
        </div>
        <ToastContainer />
        {/* <!-- Container-fluid Ends--> */}
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    allCustomers: state.loans.allCustomers,
  };
};

export default connect(mapStateToProps, {
  getAllCustomerLoansRedux,
})(Customers);
